import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Card, CardBody } from "reactstrap";
import moment from "moment";

import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";
import ALoader from "views/pages/manage/common/a-loader";
import Filters from "./Filters";

import { ReceiptListContext } from "./context";
import {
  emptySearchFields,
  getBusinessAreasDropdown,
  getReceiptsList,
} from "./constants";
import ManageReceiptsList from "./ManageReceiptsList";
import { getCookie } from "../../../../common/utils/methods/commonMethods/utilityMethod";

const ManageReceipts = ({
  isCentralizedAdm = false,
  centralizedRowsData = [],
}) => {
  const history = useHistory();

  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns
  );
  const { globalFilter, setGlobalFilter } = useContext(ReceiptListContext);

  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [isLastPage, setIsLastPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPageNumber, setPageNumber] = useState(0);

  const [businessAreaOptions, setBusinessAreaOptions] = useState(
    masterDropdowns?.allBusinessAreaList || []
  );

  useEffect(() => {
    // initial load
    if (!isCentralizedAdm) fetchListFromApi();

    if (!masterDropdowns?.allBusinessAreaList.length) {
      fetchDropdown();
    }
  }, []);

  const formatBUDropdown = (response) => {
    const options = response.map((item) => ({
      label: `${item.businessAreaDispValue}`,
      value: item.businessAreaDispValue,
      businessAreaId: item.id,
    }));

    setBusinessAreaOptions(options);
  };

  const fetchDropdown = async () => {
    // setDropdownLoader(true);
    const res = await getBusinessAreasDropdown();
    formatBUDropdown(res);

    // setDropdownLoader(false);
  };

  const fetchListFromApi = async (filters = {}, offset = 0) => {
    setIsLoading(true);

    let payload = { ...filters };

    if (!filters?.businessAreaList || filters.businessAreaList.length === 0) {
      // handle if user try to submit empty business area because api send all data in that case
      payload = {
        ...filters,
        businessAreaList:
          masterDropdowns?.allBusinessAreaList || businessAreaOptions,
      };
    }
    if (!filters?.startDate) {
      payload = {
        ...payload,
        startDate: new Date(moment().startOf("day")).toISOString(),
        endDate: new Date(moment().endOf("day")).toISOString(),
      };
    }

    const response = await getReceiptsList({ payload, page: offset });

    setIsLoading(false);

    if (response?.code === 200) {
      const { totalRecords, receiptsResponseDTOList } = response.data;
      setRowCount(totalRecords);
      setRows(receiptsResponseDTOList);
      setIsLastPage && setIsLastPage(!receiptsResponseDTOList.length > 0);
    } else {
      setRowCount(0);
      setRows([]);
    }
  };

  const onPageChange = (newPage) => {
    setPageNumber(newPage);
    fetchListFromApi(globalFilter, newPage);
  };

  const updateReceiptsList = (updatedFields = {}) => {
    setPageNumber(0);
    const newFilter = { ...globalFilter, ...updatedFields };

    fetchListFromApi(newFilter, 0);
  };

  const setFilterForm = (f) => {
    setGlobalFilter({ ...f });
  };

  const crossInputHandler = () => {
    setFilterForm({ ...globalFilter, ...emptySearchFields });
    updateReceiptsList(emptySearchFields);
  };

  const searchInputValueHandler = (name) => {
    // If you want to update filterForm or other fields, you can pass them in `updateReceiptsList`
    updateReceiptsList();
  };

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 100px)",
      }}
    >
      <Card
        className={`mb-2 ${isCentralizedAdm ? "mx-0" : "mx-3"}`}
        style={{ flexGrow: 1 }}
      >
        <CardBody style={{ display: "flex", flexFlow: "column" }}>
          {!isCentralizedAdm && (
            <div className="search-match-container">
              <div
                className={`d-flex align-items-center`}
                style={{ height: "min-content" }}
              >
                <BackIcon
                  className="mr-2 large-text"
                  onClick={() => history.goBack()}
                />
                <div className="heading-3 color-black-60 text-bold">
                  Manage Receipts
                </div>
              </div>

              <Filters
                crossInputHandler={crossInputHandler}
                searchInputValueHandler={searchInputValueHandler}
                isLoading={isLoading}
                businessAreaOptions={businessAreaOptions}
                updateReceiptsList={updateReceiptsList}
              />
            </div>
          )}

          {isLoading ? (
            <ALoader />
          ) : (
            <ManageReceiptsList
              rows={isCentralizedAdm ? centralizedRowsData : rows}
              isLoading={isLoading}
              isLastPage={isLastPage}
              // rowCount={rowCount || 0}
              onPageChange={onPageChange}
              currentPage={currentPageNumber || 0}
              businessAreaOptions={businessAreaOptions}
              isCentralizedAdm={isCentralizedAdm}
              opportunityOwnerId = { isCentralizedAdm && getCookie('userId')}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default ManageReceipts;
